import { useQuery } from '@apollo/client';
import get from 'lodash.get';
import { billingTransacitonSummaryQuery } from './totalsQuery';
import { getConsolidatedTypeFilter, mapToServiceFilter } from './util';

const summaryType = ['BILL'];

export const getBillingTransactionSummaryQueryParameters = ({
  billingTransactionFilter,
  contextFilter,
  dueDate
}) => {
  const consolidatedTypeFilter =
    billingTransactionFilter.transactionTypes &&
    billingTransactionFilter.transactionTypes.length > 0
      ? getConsolidatedTypeFilter(
          billingTransactionFilter.transactionTypes,
          summaryType
        )
      : summaryType;

  return {
    variables: {
      filter: mapToServiceFilter({
        contextFilter,
        billingTransactionFilter,
        consolidatedTypeFilter,
        billStatus: [],
        dueDate
      })
    },
    skip: !consolidatedTypeFilter.length > 0,
    fetchPolicy: 'network-only'
  };
};

export const useBillingTransactionSummary = (
  billingTransactionFilter,
  contextFilter,
  dueDate
) => {
  const param = getBillingTransactionSummaryQueryParameters({
    billingTransactionFilter,
    contextFilter,
    dueDate
  });

  const { data, loading } = useQuery(billingTransacitonSummaryQuery, param);

  const billingTransacitonSummary = get(
    data,
    'getBillingTransactionSummary',
    {}
  );

  return { loading, billingTransacitonSummary };
};

export default useBillingTransactionSummary;
